import React from 'react';
import PropTypes from 'prop-types';

import './bar-loader.css';

const BarLoader = (props) => {
	return (
		<div className="bar-loader">
			<div className="bar-loader__content">
				<h3 className="bar-loader__title">{props.title}</h3>
				<span className="bar-loader__loader"></span>
			</div>
		</div>
	);
};

BarLoader.propTypes = {
	title: PropTypes.string.isRequired,
}

export default BarLoader;


// WEBPACK FOOTER //
// ./src/components/common/loaders/BarLoader/index.js